import { useEffect, useState } from "react";
import {
    BoxButtonFilter,
    FilterAccordion,
    FilterAccordionDetails,
    FilterAccordionSummary,
    FilterBox,
    FilterMachineMessage,
    IconClose,
    useClasses,
} from "./FilterSearch.style";
import { Button } from "@mui/material";
import { FilterSearchContent } from "./FilterSearchContent";
import ServiceProvider from "../../../../configuration/ServiceProvider";
import { Machine, Site } from "../../../../../explorer/types/SpareParts";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { AppIconsClose } from "../../../../components/AppIcons";
import {
    KeyboardArrowDownOutlined,
    KeyboardArrowUpOutlined,
} from "@mui/icons-material";
import useBrands from "../../../../../explorer/hooks/useBrands";
import useCurrentSite from "../../../../hook/useCurrentSite";

type optionType = {
    id: string;
    label: string;
};

interface FilterProps {
    expandFilters: boolean;
    setExpandFilters: any;
    applyFilter:boolean;
    setApplyFilter:any;
    machineFilterApplied:string;
    setSelectedSortType: any;
    setSelectedMachineCode: any;
    setSelectedMachineLabel:any;
    currentMachine?: Machine;
}
export const FilterSearch = (props: FilterProps) => {
    const { t } = useTranslation();

    const classes = useClasses();

    const [siteSelected, setSiteSelected] = useCurrentSite();

    const sortOrders: optionType[] = [
        { id: "", label: t("common.spareparts.search.orderedType.select") },
        {
            id: "ASC",
            label: t("common.spareparts.search.orderedType.descrAsc"),
        },
        {
            id: "DESC",
            label: t("common.spareparts.search.orderedType.descrDesc"),
        },
    ];
    const [openFilters, setOpenFilters] = useState(false);

    const brand = useBrands().currentBrandUrl;

    const [sortOrderSelected, setSortOrderSelected] = useState<optionType>(
        sortOrders[0]
    );
    const [machineFilterSelected, setMachineFilterSelected] =
        useState<optionType>({
            id: "",
            label: t("common.spareparts.all_machines"),
        });

    
    const handleFilterClick = function () {
        props.setExpandFilters(!props.expandFilters);
    };

    const handelXClick = function () {
        setMachineFilterSelected({
            id: "",
            label: t("common.spareparts.all_machines"),
        });
        setSortOrderSelected(sortOrders[0]);
        props.setApplyFilter(true);
    };

    useEffect(() => {
        props.setSelectedSortType(sortOrderSelected.id);
        props.setSelectedMachineCode(machineFilterSelected.id);
        props.setSelectedMachineLabel((machineFilterSelected===undefined) ? "" : machineFilterSelected.label);
        
    }, [sortOrderSelected, machineFilterSelected]);

    
    return (
        <FilterBox>
            <FilterAccordion expanded={props.expandFilters}>
                <FilterAccordionSummary>
                    <BoxButtonFilter>
                        {props.machineFilterApplied !== ""  &&(
                            <FilterMachineMessage>
                                {/*{t("common.spareparts.search.filter")} :{" "} */}
                                {props.machineFilterApplied}
                                <IconClose onClick={handelXClick}>
                                    <AppIconsClose />
                                </IconClose>
                            </FilterMachineMessage>
                        )}

                        <Button
                            variant="text"
                            color="primary"
                            style={{
                                marginRight: "10px",
                                textTransform: "uppercase",
                            }}
                            startIcon={
                                props.expandFilters ? (
                                    <KeyboardArrowUpOutlined />
                                ) : (
                                    <KeyboardArrowDownOutlined />
                                )
                            }
                            onClick={handleFilterClick}
                        >
                            {t("common.spareparts.search.display_filters")}
                        </Button>
                    </BoxButtonFilter>
                </FilterAccordionSummary>
                <FilterAccordionDetails>
                    <FilterSearchContent
                        machineFilterSelected={machineFilterSelected}
                        setMachineFilterSelected={setMachineFilterSelected}
                        open={props.expandFilters}
                        setOpen={props.setExpandFilters}
                        sortOrders={sortOrders}
                        sortOrderSelected={sortOrderSelected}
                        setSortOrderSelected={setSortOrderSelected}
                        applyFilter={props.applyFilter}
                        setApplyFilter={props.setApplyFilter}
                    />
                </FilterAccordionDetails>
            </FilterAccordion>
        </FilterBox>
    );
};
